import React from 'react';
import { Nav, Tab, Row, Col, Image, Container } from 'react-bootstrap';
import Book from '../Pics/book.png';

const fixed = {
  backgroundImage: `url('https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png')`,
};


function Publications() {
  return (
    <div>
     
     <div id="resources" className="offset">
        <div className="fixed-background">
          <div className="row dark text-center ">
            <Col sm="12">
              <br />
              <br />
              <br />
              <br />
              <br />
              <h3 className="heading headers">Publications</h3>

              <br />
              <br />
              <br />
              <br />
              <div className="heading-underline"></div>
            </Col>
          </div>

          <div className="fixed-wrap">
            <div className="fixed" style={fixed}></div>
          </div>
        </div>
      </div>

      <Container>
        <Tab.Container defaultActiveKey="first">
          <Row>
            <Col sm={4} className="publication_col">
              <h1 className="text-center">Categories</h1>
              <div className="list-unstyled">
                <ul className="list-unstyled publication_list">
                  <li className="publication_item">
                    <Nav.Item className="publication_item">
                      <Nav.Link eventKey="first" className="publication_text">Books/Monographs</Nav.Link>
                    </Nav.Item>
                  </li>
                  <li>
                    <Nav.Item>
                      <Nav.Link eventKey="second" className="publication_text">Edited Books</Nav.Link>
                    </Nav.Item>
                  </li>
                  <li>
                    <Nav.Item>
                      <Nav.Link eventKey="third" className="publication_text">Peer Reviewed Journal Papers</Nav.Link>
                    </Nav.Item>
                  </li>
                  <li>
                  <li>
                    <Nav.Item>
                      <Nav.Link eventKey="fourth" className="publication_text">Papers Accepted for Publication</Nav.Link>
                    </Nav.Item>
                  </li>
                    <Nav.Item>
                      <Nav.Link eventKey="fifth" className="publication_text">Peer Reviewed Conference/Workshop Proceedings</Nav.Link>
                    </Nav.Item>
                  </li>
                 
                  <li>
                    <Nav.Item>
                      <Nav.Link eventKey="sixth" className="publication_text">Commissioned Technical/Research Reports</Nav.Link>
                    </Nav.Item>
                  </li>
                  <li>
                    <Nav.Item>
                      <Nav.Link eventKey="seventh" className="publication_text">Public Lectures and Seminars</Nav.Link>
                    </Nav.Item>
                  </li>
                </ul>
              </div>
            </Col>

            <Col md="8" lg="8" sm="8" className="publication_col">

              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <div className="publication_div">
                    <h1 className="publication_header text-center">Books/Monographs</h1>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>I. R. Ajayi (2011) Radiation Bombardments on our earth: Are we safe:- 4th Inaugural Lecture of the Adekunle Ajasin University Akungba-Akoko held on 26th July, 2011 at Adekunle Ajasin University Akungba-Akoko.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>I.R. Ajayi, (2000) Concise Mechanics for Scientists and Engineers – Tessac Publications, Ado-Ekiti.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>I. R. Ajayi& D. D. Abajingin (2004), General Physics for University Students Vol.II, Tessac Publication, Ado-Ekiti</p>
                      </Col>
                    </Row>
                    <hr />

                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>I. R. Ajayi, F.Ojelabi & K.A. Adeloju (2003)Basic Electricity and   Magnestism – Tessac Publications, Ado-Ekiti.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>I. R. Ajayi, D. D. Abajingin, A. O. Ajagunna & R. S. Fayose (2001): Pre-Varsity Physics published by Classic Educational Publishers, Akure</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>I. R. Ajayi,  F. O. Akinwumi & N. A. Oladoja (2010): Proceedings of the 2nd International Biennial Conference of the  Faculty of Science, Adekunle Ajasin University, Akungba-Akoko on Issues and Challenges of Climate Change, 8th – 11th November, 2010</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="second">

                  <div className="publication_div">
                    <h1 className="publication_header text-center">Edited Books</h1>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Ajayi I. R. (2016): Potent and Sustainable Solutions to Tackling Violent Extremism and Radicalization, pp.165. A chapter in Human Security, Violent Extremism and Radicalisation: Seeking Sustainable Solutions.  Edited by Akin L. Mabogunje and Peter A. Okebukola and Published by Published by Centre for Human Security.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Akingbesote A.O., Fisusi R.Z., Olofinsao J.A., Iwasokun  G.B.  and  Olatubosun  A.E. (2007): An
                           Introduction to Information and Communication Technology, Edited by I.R. Ajayi, Published by Amure Printers.
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                </Tab.Pane>

                <Tab.Pane eventKey="third">

                  <div className="publication_div">
                    <h1 className="publication_header text-center">Peer Reviewed Journal Papers</h1>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Asere A.M and Ajayi I. R. (2017). Estimation of outdoor gamma dose rate and lifetime cancer risk in Akoko region, Ondo State, Southwestern, Nigeria. IOSR journal of environmental science, toxicology and food technology. Vol 11 issue 5 vear 2, 49-52</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Asere A.M and Ajayi I. R. (2017). Estimation of Indoor radon and its progeny in dwellings of Akoko region, Ondo state, Southwestern Nigeria. Journal of scientific research and reports. 14(3), 1-7.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Asere A.M. and Ajayi I. R. (2015). Exposure to ionizing radiation and radiological implications: a review of ICRP, IAEA and UNSCEAR recommendations. The international journal of engineering and science. 4(6), 29-33.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Asere A.M and Ajayi I.R.(2015). Exposure to radon as a public health issue- A review. Journal of scientific research and reports. 8(3), 1-7.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Ojo J. T. &Ajayi I. R. (2015):  Outdoor Radon Concentration in the township of Ado-Ekiti, Nigeria. Journal of Atmospheric Pollution, Vol 3, No1, pp 18-21.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Ojo J. T. &Ajayi I. R. (2014): A Review on Environmental Radon and its Potential Health Risk on Humans. Journal of Environmental Science, Toxicology and Food Technology (10SR-JESTFT) Vol.8, Issue 1 pp.01 (India)</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Mohammed M. Z. &Ajayi I. R. (2014): Geoelectric Evaluation of Subsoil for Optimum Cocoa Yield in Parts of Ondo State South West Nigeria. Journal of Civil & Environmental Research, USA, Vol 6, No.1, pp1-8(USA)</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Alao O. A. and Ajayi. I. R. (2013): A Review of Recent Studies on Brain Exposure to RF Radiations. Global Advanced Research Journal of Scientific Research and Essays, Vol. 1(1) pp.001-005 (Nigeria)</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>O.M. Afolabi, I.R. Ajayi, R.S. Fayose,. Olubosede and A.G. Sunday (2011): Nickel and iron Concentration level in Water Samples from Hand-dug Wells from Ugbe Akoko, Ondo State.  American Journal of Applied Science, 8(2):pp 182-185 (USA)</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>I. R. Ajayi ,O.M.  Afolabi, E.F. Ogunbodede and A.G. Sunday (2010: Modeling  Rainfall of  as a Constraining factor for Cocoa  yield in Ondo. American Journal of  Scientific  and  Industrial Research  doi:10.5251/AJSIR. 2010.1.2.127.134  PP. 127-134. (USA).</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>I. R.Ajayi , and  A.T. Raji  (2010)  Evaluation of the 137Cs activity-depth Profiles by the  Diffusion-convection Model, International Journal of the Physical Sciences Vol. 5  (2) pp 154-157. Academic Journals.( Kenya).</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="fourth">

                  <div className="publication_div">
                    <h1 className="publication_header text-center">Papers Accepted for Publication</h1>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                      <p>Afolabi O. M., Aboluwoye C. O. &Ajayi I. R. (2014): Gamma Ray Spectrometry Analytical Determination of Radiation Levels in Bitumen Deposit Areas of Agbabu and Environment.  Journal of Environmental & Analytical Toxicology, Vol. 4, Issue 2, (USA)</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                </Tab.Pane>

                 <Tab.Pane eventKey="fifth">

                  <div className="publication_div">
                    <h1 className="publication_header text-center">Peer Reviewed Conference/Workshop Proceedings</h1>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                      <p>I. R. Ajayi, Babalola R. A. & Ajayi O. S (1998): determination of Concentration of Selected Radionuclides in Soils in a Part of SouthWest, Nigeria.  3rd Edward Bouchet International Conference of Physics and High Technology for Development in Africa. 10 – 14 August, 1998, Botswana</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>Afolabi O. M., Ajayi I. R.and Bamisile A. M. 2010: Mercury and Lead Concentration Levels Determination with AAS in Water Samples from Hand-dug wells from Ugbe Akoko. Proceedings at the 2nd International Bi-ennial Conference of the Faculty of Science, Adekunle Ajasin University, on Issues & Challenges of Climate Change
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                      <p>I.R. Ajayi  (2001) : Electromagnetism Made Simple: Proceeding of the Science Teachers’ Association of Nigeria, (STAN) National Physics Workshop at Ado-Ekiti in May 2011.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                </Tab.Pane>

                 <Tab.Pane eventKey="sixth">

                  <div className="publication_div">
                    <h1 className="publication_header text-center">Commissioned Technical/Research Reports</h1>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                      <p>I. R. Ajayi: Sustainable Optimum Cocoa Production in Ondo State Using Remote Sensing and Geographic Information Systems. A Technical Report Submitted to National Space Research and Development Agency, (NASRDA), Abuja</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                       <p>I. R. Ajayi& O. Yoloye (1998): Report of a Radiological Inspection Visit to X-ray Facilities in Aso Rock Clinic, Abuja: Commissioned by the Federal Government of Nigeria</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                       <p>I. R. Ajayi& P.A. Adefisoye (1998): Report of Radiation Leakage Inspection to Eleme Petrochemical Industrial  Clinic in Port-Harcourt, Nigeria. Commissioned by the Authority of Eleme Petrochemical Industry, Port Harcourt, Rivers State</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                       <p>I. R. Ajayi (1997): Report of the Radiological Inspection Visit to Ajaokuta   Steel Company, Ajaokuta to Assess Radiological Hazards of spent sources. Commissioned by Ajaokuta Steel Company, Ajaokuta, Kogi State</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>


                </Tab.Pane>


             <Tab.Pane eventKey="seventh">

                  <div className="publication_div">
                    <h1 className="publication_header text-center">Public Lectures and Seminars</h1>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                      <p>I. R. Ajayi, (2018): Global Research Funding Opportunities.  An invited Paper presented at the Humboldt-Kollegthe Role of Commercialisation of University-Based Research Results For National Development held at Adekunle Ajasin University, Akungba-Akoko, Nigeria, 4-7 June, 2018.</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>I. R. Ajayi  (2012): African Universities and the Challenges of Research Capacity. A Key Note Address presented at the Ekiti State University Maiden Research Conference and Fair, September 2012
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>
                        I. R. Ajayi: Rapid Response and Emergency Preparedness Against Natural Disasters.  A Lecture presented at the UBEC Workshop for Education Managers in Ondo State in July,  2012
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>
                        I. R. Ajayi (2011): The Culture of Working at the Global University:  My Experience.  A Paper presented at the Retreat on Understanding the Culture of the University at Adekunle Ajasin University, Akungba-Akoko, February 2011
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>
                        I. R. Ajayi (2011): Responsibilities of Deans, Directors & HODs in Universities.  A Paper presented at the Retreat on Understanding the Culture of the University at Adekunle Ajasin University, Akungba-Akoko, February 2011
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>
                        I. R. Ajayi  (2011): ICT in University Administration: A Paper presented at the Retreat on Quality Assurance for Institutional Stability in Adekunle Ajasin University, Akungba-Akoko
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>
                        I. R. Ajayi(2008): The Imperatives of ICT Capabilities for 21st Century Students, A Lecture presented at the Bisi Ogunjobi Foundation day in 2008
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>
                        I. R. Ajayi (2007): The Transport at Cs-137 in Soil: A Seminar Paper presented at ICTP Seminars in Applied Physics November 2007
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>
	                      I. R. Ajayi,(2006) , : The Economics of Book Publishing: A Paper presented at the Workshop on Book Development Skills Training & Capacity Building for Teachers Organized by ETF at FCA, Akure 21 – 25 November, 2006.
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>

                  <div>
                    <Row className="">
                      <Col sm={2}>
                        <Image src={Book} className="Publication_icon" />
                      </Col>
                      <Col>
                        <p>
                        I. R. Ajayi, (1999): Medical and Industrial Applications of Radiation.  A Paper presented at the Workshop on Radiation Protection & Quality Assurance in Medical & Industrial Practices Organized by the Federal Radiation Protection Service, University of Ibadan, 15th – 19th November, 1999.
                        </p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>

        </Tab.Container>
      </Container>
    </div>
  )
}

export default Publications;